import { Component } from '@angular/core';

@Component({
  selector: 'app-club-content-session-types-report',
  templateUrl: './club-content-session-types-report.component.html'
})
export class ClubContentSessionTypesReportComponent {

}
